import { type MonetaryValue } from 'ezmoney';
import React, { useState } from 'react';

import {
  type ExpenseBill,
  type InvoiceBill,
} from 'src/core/modules/invoices/models';

import { WireTransfersSentToPaymentModal } from './WireTransfersSentToPaymentModal';
import { WireTransfersSummaryModal } from './WireTransfersSummaryModal';

enum ControllerModalStep {
  Summary,
  Confirmation,
}

type Props = {
  showNotEnoughFundsWarning: boolean;
  isSendingToPayment: boolean;
  isOpen: boolean;
  selectedPayments: Array<{
    id: string;
    bill: InvoiceBill | ExpenseBill | undefined;
    amount: MonetaryValue;
  }>;
  onSendToPayment: (options?: { onSuccess: () => void }) => void;
  onClose: () => void;
  onComplete: () => void;
};

const WireTransferControllerModal = ({
  selectedPayments,
  showNotEnoughFundsWarning,
  isSendingToPayment,
  isOpen,
  onSendToPayment,
  onClose,
  onComplete,
}: Props) => {
  const [currentStep, setCurrentStep] = useState<ControllerModalStep>(
    ControllerModalStep.Summary,
  );

  const handleSendToPayment = async () => {
    await onSendToPayment({
      onSuccess: () => {
        setCurrentStep(ControllerModalStep.Confirmation);
      },
    });
  };

  const handleComplete = () => {
    handleClose();
    onComplete();
  };

  const handleClose = () => {
    onClose();
    setCurrentStep(ControllerModalStep.Summary);
  };

  return (
    <>
      <WireTransfersSummaryModal
        selectedPayments={selectedPayments}
        isApproving={isSendingToPayment}
        canApprove={false}
        showNotEnoughFundsWarning={showNotEnoughFundsWarning}
        onApprove={handleSendToPayment}
        onClose={handleClose}
        isOpen={isOpen && currentStep === ControllerModalStep.Summary}
      />
      <WireTransfersSentToPaymentModal
        count={selectedPayments.length}
        onComplete={handleComplete}
        isOpen={isOpen && currentStep === ControllerModalStep.Confirmation}
      />
    </>
  );
};

export default WireTransferControllerModal;
